import { NavLink, withRouter } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { selectUserInfo } from '../../store/selectors/userInfo';
import { selectSubMenu } from '../../store/selectors/submenu';
import { useIntl } from 'react-intl';

const SubMenuComponent = () => {
  const userInfo = useSelector(selectUserInfo);
  const subMenuReducer = useSelector(selectSubMenu);
  const { formatMessage } = useIntl();

  if (userInfo.status === 'COMPLETED') {
    return (
      <section className={`SubMenuComponent ${subMenuReducer.subMenuOpen ? 'opened' : 'closed'}`}>
        <div className={'subMenuElement-list'}>
          <div className='section'>
            <ul className='links'>
              {subMenuReducer.subMenuItems.map((navElement) => {
                const preparedId = `${navElement.substring(1)}-label`;

                return (
                  <li key={preparedId}>
                    <NavLink to={navElement} className='subMenuElement-link'>
                      {formatMessage({
                        id: preparedId,
                      })}
                    </NavLink>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </section>
    );
  } else {
    return <></>;
  }
};

export default withRouter(SubMenuComponent);
